import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// GET /api/v1/academy-topics/?enabled=true → only enabled topics of my academy.
// Teachers may only plan classes with topics the owner has enabled.
function useAcademyTopics() {
  return useQuery({
    queryKey: ["academy-topics", "enabled"],
    queryFn: () =>
      apiClient
        .get("/api/v1/academy-topics/?enabled=true")
        .then((r) => r.data),
  });
}

// POST /api/v1/topic-proposals/ → teacher proposes a new topic (PENDING).
function useProposeTopic() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      apiClient.post("/api/v1/topic-proposals/", body).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["topic-proposals"] });
    },
  });
}

export { useAcademyTopics, useProposeTopic };
